@for (p of points; track trackByFn($index, p)) {
<app-point
  [data]="p"
  [area]="area"
  [streamId]="stream().id"
  (destroyed)="pointerDestroyed($event)"
></app-point>
}
